import { RG_TYPE as t } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel as e } from "../../../utils/rg-util/index3.js";
import { isMiscDoor as i } from "../../queries/index6.js";
const f = (o, r) => e(o, t.Door, r).filter(i).length;
export {
  f as getLevelMiscDoorsCount
};
//# sourceMappingURL=index23.js.map
